<div class="branding">

  @if (showRings) {
    <img src='/assets/images/rings-large.png' class="rings fadein" alt="General Pharmaceutical Council rings"
      aria-hidden="true" />
  }
  @if (username) {
    <div class="user"  aria-hidden="true" tabindex="-1">
      <i class="fa fa-user"></i>&nbsp;&nbsp;{{username}}
      <!--| <a class="clickable" (click)="signout()">Sign out</a>-->
    </div>
  }
  <div class="mygphc">

    <span class="mygphc-logo">myGPhC</span>
    <div class="mygphc-logo admin">admin</div>

    <div aria-hidden="true" tabindex="-1" class="version clickable" [routerLink]="'/diagnostics'">V{{appVersion}}</div>
  </div>

  <span class="logo" (click)="goHome()">
    <img src="/assets/images/logo-GPhC-blue-cropped.png" alt="General Pharmaceutical Council logo" />
  </span>
</div>